<template>
  <div v-if="show" class="disclaimer-modal">
    <div class="modal-content">
      <h2>Legal Disclaimer</h2>
      <div class="disclaimer-content">
        <p>Welcome to our gaming platform. Please read this disclaimer carefully:</p>
        
        <h3>1. Copyright Notice</h3>
        <p>The games displayed on this platform are sourced from the internet or uploaded by users. We respect and protect intellectual property rights. If you find any content on this platform that infringes upon your legal rights, please contact us immediately at <a href="mailto:martnetqjs@hotmail.com">martnetqjs@hotmail.com</a>. Upon receiving your notification, we will promptly take appropriate measures.</p>
        
        <h3>2. Content Disclaimer</h3>
        <p>This platform only provides game display and linking services and is not responsible for third-party game content. Users should exercise their own judgment regarding the legality, safety, and suitability of third-party games. Any risks and responsibilities arising from the use of third-party games are borne by the user.</p>
        
        <h3>3. DMCA Compliance</h3>
        <p>We comply with the Digital Millennium Copyright Act (DMCA). If you believe your copyrighted work has been used inappropriately on our platform, please send a written notification to the contact email provided above, including the following information:</p>
        <ul>
          <li>Identification of the copyrighted work claimed to have been infringed</li>
          <li>Identification of the material that is claimed to be infringing</li>
          <li>Your contact information</li>
          <li>A statement that you have a good faith belief that the use is not authorized</li>
          <li>A statement that the information is accurate and, under penalty of perjury, you are authorized to act on behalf of the copyright owner</li>
        </ul>
        
        <h3>4. GDPR Compliance</h3>
        <p>In accordance with the General Data Protection Regulation (GDPR), we protect the personal data of our users. By using this platform, you consent to the collection and processing of your data as outlined in our Privacy Policy.</p>
        
        <h3>5. Age Restrictions</h3>
        <p>This platform is intended for users who meet the legal age requirements in their jurisdiction. Minors should use this platform only under the supervision of a guardian and in compliance with relevant laws and regulations regarding the online protection of minors.</p>
        
        <h3>6. Service Modifications</h3>
        <p>We reserve the right to modify or discontinue the service at any time without prior notice and without liability to any third party.</p>
        
        <h3>7. Limitation of Liability</h3>
        <p>To the fullest extent permitted by law, we disclaim all warranties, express or implied, and shall not be liable for any damages arising from the use or inability to use our platform.</p>
      </div>
      <div class="modal-footer">
        <button @click="close">I Understand</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}
</script>

<style scoped>
.disclaimer-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

h2 {
  padding: 20px;
  margin: 0;
  text-align: center;
  color: #1a1a2e;
  background: #f5f5f5;
  border-bottom: 1px solid #eee;
}

.disclaimer-content {
  padding: 20px;
  overflow-y: auto;
  line-height: 1.6;
}

h3 {
  color: #1E90FF;
  margin-top: 20px;
  margin-bottom: 10px;
}

p {
  margin-bottom: 15px;
  color: #333;
}

ul {
  margin-bottom: 15px;
  padding-left: 25px;
}

li {
  margin-bottom: 8px;
  color: #333;
}

a {
  color: #1E90FF;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.modal-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #eee;
  background: #f5f5f5;
}

button {
  padding: 10px 20px;
  background: #1E90FF;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover {
  background: #1873CC;
  transform: translateY(-2px);
}
</style> 